import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { ActionReducer, createReducer, on } from '@ngrx/store';
import { DesignComponent } from '@design/models/design-component.model';
import { fromDesignComponentActions } from './design-component.action';
import { DesignComponentState } from './design-component.state';

export const adapter: EntityAdapter<DesignComponent> =
  createEntityAdapter<DesignComponent>({});

export const DesignComponentInitialState: DesignComponentState =
  adapter.getInitialState();

export const { selectAll } = adapter.getSelectors();

export const designComponentReducer: ActionReducer<DesignComponentState> =
  createReducer(
    DesignComponentInitialState,
    on(fromDesignComponentActions.AddDesignComponent, (state, data) => {
      return adapter.addOne(data.designComponent, state);
    }),
    on(fromDesignComponentActions.AddManyDesignComponents, (state, data) => {
      return adapter.addMany(data.designComponents, state);
    }),
    on(
      fromDesignComponentActions.DesignComponentConfigurationChange,
      (state, { designComponent }) => {
        return adapter.updateOne(
          { id: designComponent.id, changes: { ...designComponent } },
          state
        );
      }
    ),
    on(
      fromDesignComponentActions.UpdateDesignComponent,
      (state, { designComponent }) => {
        return adapter.updateOne(
          { id: designComponent.id, changes: { ...designComponent } },
          state
        );
      }
    ),
    on(
      fromDesignComponentActions.DeleteDesignComponent,
      (state, { designComponent }) => {
        return adapter.removeOne(designComponent.id, state);
      }
    ),
    on(
      fromDesignComponentActions.DeleteDesignComponentFromStore,
      (state, { designComponent }) => {
        return adapter.removeOne(designComponent.id, state);
      }
    ),
    on(fromDesignComponentActions.ClearDesignComponents, (state) => {
      return adapter.removeAll(state);
    })
  );
